import { useEffect, useState } from 'react';
import { getPlugins } from '../api/pluginsApi';

/**
 * The plugin map, and one plugin out of it.
 *
 * `getPlugins` caches the request, so every page that mounts shares one round trip and a
 * second navigation resolves synchronously from the cached promise. The `live` flag is the
 * usual guard against a resolve landing after the user has already navigated away, which
 * happens on the first paint of a deep link while the list is still in flight.
 */
export function usePlugins() {
  const [state, setState] = useState({ plugins: null, loading: true, failed: false });

  useEffect(() => {
    let live = true;
    getPlugins()
      .then((plugins) => live && setState({ plugins, loading: false, failed: false }))
      .catch(() => live && setState({ plugins: null, loading: false, failed: true }));
    return () => {
      live = false;
    };
  }, []);

  return state;
}

export function usePlugin(pluginName) {
  const { plugins, loading, failed } = usePlugins();
  return { plugin: plugins ? plugins[pluginName] : undefined, loading, failed };
}
